import type { FC } from "react";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import { NotificationCenterFilterChip } from "web_myplann/NotificationCenter/Components/NotificationCenterFilterChip";
import type { NotificationCenterTab } from "web_myplann/NotificationCenter/Constants/notificationCenterTabs";
import { useNotificationCenterCounts } from "web_myplann/NotificationCenter/Hooks/useNotificationCenterCounts";
import { ListCountBarRedesign } from "web_myplann/Shared/Components/Redesign/ListCountBarRedesign";

type NotificationCenterListBarProps = {
	activeTab: NotificationCenterTab;
	disableBottomPadding?: boolean;
};

export const NotificationCenterListBar: FC<NotificationCenterListBarProps> = ({
	activeTab,
	disableBottomPadding,
}) => {
	const { shown } = useNotificationCenterCounts(activeTab);

	return (
		<ListCountBarRedesign
			count={shown}
			labelKey={
				shown !== undefined ? Resources.Common.ListBar.itemsCount : undefined
			}
			action={<NotificationCenterFilterChip activeTab={activeTab} />}
			disableBottomPadding={disableBottomPadding}
		/>
	);
};
